import {Component, OnInit, AfterViewInit, ViewChild, OnDestroy} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {StorageService} from '../../../Services/storage.service';
import {DataService} from '../../../Services/data.service';
import {NotificationService} from '../../../Services/notification.service';
import {FilterPipe} from 'ngx-filter-pipe';
import {DateFilterService} from '../../../Services/dateFilter.service';
import {Title} from '@angular/platform-browser';
import {AppConfigService} from '../../../Services/app-config.service';
import {ResponseModel} from '../../../DataModels/response-model';
import {PagerStateService} from '../../../Services/pager-state.service';
import {ConfirmDialogService} from '../../../Services/confirm-dialog.service';
import {take} from 'rxjs/operators';
import {ShipmentDocumentService} from '../../../Services/shipment-document.service';
import {PermissionsService} from '../../../Services/permissions.service';
import {ListPageBase} from '../../list-page-base';

@Component({
  selector: 'app-shipment-list',
  templateUrl: './shipment-list.component.html',
  styleUrls: ['./shipment-list.component.css'],
  standalone: false
})
export class ShipmentListComponent extends ListPageBase implements OnInit, AfterViewInit, OnDestroy {
  constructor(
    private route: ActivatedRoute,
    private localStorage: StorageService,
    private tableDataService: DataService,
    private notification: NotificationService,
    private dateFilter: DateFilterService,
    private titleService: Title,
    public confirmDialog: ConfirmDialogService,
    private shipmentDoc: ShipmentDocumentService,
    private permissionsService: PermissionsService,
  ) {
    super();
    this.vm.list = {};
    this.vm.batches = {};
    this.vm.shipmentSearch = null;
    this.vm.company = [];
  }

  get hasEditPurchaseShipmentPermission(): boolean {
    return this.permissionsService.Get('Admin') ||
      this.permissionsService.Get('EditPurchaseShipments');
  }

  shipmentCount = 0;
  isLoaded = false;
  vm: any = {};


  submitted = false;
  urlParams: any;
  batchType: any;
  shipIdNew = '';
  hasShipped = false;

  ngOnInit() {
    this.restorePagerState();
    this.vm.list = [];
    // Restore pager from enhanced per-tab cache (include subLedger in key when present)
    this.vm.permissions = JSON.parse(this.localStorage.StorageGet('Permissions'));
    if (
      !this.vm.permissions.EditReceivableShipments &&
      !this.vm.permissions.ViewReceivableShipments &&
      !this.vm.permissions.EditPayableShipments &&
      !this.vm.permissions.ViewPayableShipments &&
      !this.vm.permissions.Admin
    ) {
      document.location.href = '/';
    }

    this.urlParams = this.route.snapshot.queryParams;
    this.vm.type = this.urlParams.type;
    this.vm.subLedger = this.urlParams.subLedger;

    // set the type passed to the form when creating a new doc.
    if (this.vm.subLedger == 'ap') {
      this.shipIdNew = 'newPS';
    } else if (this.vm.subLedger == 'ar') {
      this.shipIdNew = 'newSS';
    }

    this.init();
  }

  ngOnDestroy(): void {
    // no legacy datatable resources to clean
  }


  routeInvoice = (id) => {
    const route = this.vm.subLedger === 'ar' ? '/transactions/invoice/ar/form' : '/transactions/invoice/ap/form';
    this.router.navigateByUrl(route + '?invoiceId=' + id);
  }

  init() {
    this.vm.batchId = '';
    this.vm.hideBatches = true;
    this.vm.searchHidden = false;
    // console.log(this.vm.type);

    this.vm.owingSelected = this.vm.totalSelected = 0;
    this.vm.shipmentToDateOpen = this.vm.shipmentFromDateOpen = false;

    this.vm.shipmentFilter = {};

    if (this.vm.unshipped === 'true') {
      this.vm.unshipped = true;
    } else if (this.vm.unshipped != true) {
      this.vm.unshipped = false;
    }
    if (this.vm.uninvoiced === 'true') {
      this.vm.uninvoiced = true;
    } else if (this.vm.uninvoiced != true) {
      this.vm.uninvoiced = false;
    }

    this.search();
    if (this.vm.subLedger == 'ar') {
      // queryDelinquentReceivables();
      // convertToNumbers();
    }
  }

  filterByDeliveryStatus(delivered: boolean | null) {
    this.vm.unshipped = delivered === false ? true : false;
    this.search();
  }

  filterByInvoiceStatus(invoiced: boolean | null) {
    this.vm.uninvoiced = invoiced === false ? true : false;
    this.search();
  }

  convertToNumbers() {
    for (const [x, value] of Object.entries(this.vm.list)) {
      this.vm.list[x].detail_total = Number(this.vm.list[x].detail_total);
      this.vm.list[x].payment_applied_total = Number(this.vm.list[x].payment_applied_total);
      this.vm.list[x].audit_sequence = Number(this.vm.list[x].audit_sequence);
    }
  }

  updateBatchesSelectedInModal(batchId: string) {
    this.getBatchItems(batchId);
    // this.paginate(false);
  }

  search() {
    this.vm.searching = true;
    this.vm.batchId = '';
    this.vm.tempDescription = '';
    let tempBatchType;
    if (this.vm.subLedger == 'ap') {
      tempBatchType = '12';
      this.batchType = '12';
    } else if (this.vm.subLedger == 'ar') {
      tempBatchType = '11';
      this.batchType = '11';
    }

    let paramString = '';
    paramString += 'batchType=' + (tempBatchType ? tempBatchType : '');
    paramString += '&search=' + (this.vm.shipmentSearch ? this.vm.shipmentSearch : '');
    paramString +=
      '&fromDate=' + (this.vm.shipmentFromDate ? this.dateFilter.GetDateFormat(this.vm.shipmentFromDate) : '');
    paramString += '&toDate=' + (this.vm.shipmentToDate ? this.dateFilter.GetDateFormat(this.vm.shipmentToDate) : '');
    paramString += '&lockedBatches=' + (this.vm.lockedBatches ? this.vm.lockedBatches : '');
    paramString += '&numberOfResults=' + (this.vm.shipmentNumberOfResults ? this.vm.shipmentNumberOfResults : '');
    paramString += '&includePosted=' + (this.vm.includePosted ? this.vm.includePosted : '');

    this.tableDataService.getData('t_batch?' + paramString).subscribe((result: any[]) => {
      this.vm.batches = result;
    });

    paramString = '';
    paramString += 'batchType=' + (tempBatchType ? tempBatchType : '');
    paramString += '&batchId=' + (this.vm.batchId ? this.vm.batchId : '');
    paramString += '&search=' + (this.vm.shipmentSearch ? this.vm.shipmentSearch : '');
    paramString += '&fromDate=' + (this.vm.shipmentFromDate ? this.dateFilter.GetDateFormat(this.vm.shipmentFromDate) : '');
    paramString += '&toDate=' + (this.vm.shipmentToDate ? this.dateFilter.GetDateFormat(this.vm.shipmentToDate) : '');
    paramString += '&unshipped=' + (this.vm.unshipped ? this.vm.unshipped : '');
    paramString += '&uninvoiced=' + (this.vm.uninvoiced ? this.vm.uninvoiced : '');
    paramString += '&numberOfResults=' + (this.vm.shipmentNumberOfResults ? this.vm.shipmentNumberOfResults : '');
    paramString += '&pageNumber=' + (this.page !== 0 ? this.page - 1 : 0);
    paramString += '&pageSize=' + this.pageSize;

    this.tableDataService.getApiListData('ListShipments?' + paramString).subscribe((result: ResponseModel) => {
      this.vm.list = result.Data;
      // console.log('orders for shipment: ', this.vm.list);
      this.totalRecords = result.totalRecords;
      this.paginate(false);
      this.hasShipped = this.vm.list.completed;
      this.convertToNumbers();
      this.vm.searching = false;
      this.isLoaded = true;
    });
  }

  generateInvoice(id) {
    const messages: string[] = [
      $localize`:Generate Invoice? @@generateInvoice:Generate Invoice?`,
      '',
    ];
    this.confirmDialog.confirmThis(
      messages,
      () => {
        // fall thru on yes
        this.generateInv(id);
      },
      () => {
        this.notification.success($localize`:Canceled @@Canceled:Canceled`);
        return;
      }
    );
  }

  generateInv(id) {
    if (this.vm.subLedger == 'ar') {
      this.router.navigateByUrl('/transactions/invoice/ar/form?invoiceId=newAR&batchId=&shipmentId=' + id);
    } else {
      this.router.navigateByUrl('/transactions/invoice/ap/form?invoiceId=newAP&batchId=&shipmentId=' + id);
    }
  }

  completeShipment(id) {
    // console.log(id);
    const messages: string[] = [
      $localize`:Mark as Shipped? @@markAsShipped:Mark as Shipped?`,
      '',
    ];
    this.confirmDialog.confirmThis(
      messages,
      () => {
        // ok - just fall thru to task
        this.completeShip(id);
      },
      () => {
        // cancelled
        this.notification.success($localize`:Canceled @@canceled:Canceled`);
        return;
      }
    );
  }

  completeShip(id) {
    if (this.vm.permissions.Admin || this.vm.permissions.EditSalesShipments || this.vm.permissions.EditSalesOrders) {
      this.vm.buttonsDisabled = true;
      const changes = {completed: 'true'};
      this.tableDataService.patch('t_header', id, changes).then(
        (item: any) => {
          // this.notification.success($localize`:Completed @@completed:Completed`);
          this.getPagedApiData();
        },
        (error) => {
          this.vm.buttonsDisabled = false;
          this.notification.error(error.description);
        }
      );
    }
  }

  getBatchItems(batchId) {
    this.submitted = false;
    this.vm.tempDescription = '';
    let tempBatchType;
    if (this.vm.subLedger == 'ap') {
      tempBatchType = '12';
      this.batchType = '12';
    } else if (this.vm.subLedger == 'ar') {
      tempBatchType = '11';
      this.batchType = '11';
    }

    this.vm.batchId = batchId;
    this.vm.searching = true;
    const obj: any = this.FilterObject(this.vm.batches, {id: this.vm.batchId}, true);
    if (obj.length == 0) {
      obj[0] = {description: '', locked: ''};
    }
    this.vm.tempDescription = (obj) ? obj[0].description : '';
    this.vm.tempBatchLocked = (obj) ? obj[0].locked : false;
    let paramString = '';
    paramString += 'batchId=' + ((this.vm.batchId) ? this.vm.batchId : '');
    paramString += '&batchType=' + ((tempBatchType) ? tempBatchType : '');
    paramString += '&pageNumber=' + ((this.page !== 0) ? this.page - 1 : 0);
    paramString += '&pageSize=' + this.pageSize;

    this.tableDataService.getApiListData('ListShipments?' + paramString).pipe(take(1)).subscribe((result: ResponseModel) => {
      this.vm.list = result.Data;
      // console.log('orders for shipment: ', this.vm.list);
      this.shipmentCount = result.totalRecords;
      this.convertToNumbers();
      this.vm.searching = false;

      this.totalRecords = result.totalRecords;
      this.paginate(false);
    });
  }

  getBatches() {
    this.vm.searching = true;
    let tempBatchType;
    if (this.vm.subLedger == 'ap') {
      tempBatchType = '12';
    } else if (this.vm.subLedger == 'ar') {
      tempBatchType = '11';
    }

    let paramString = '';
    paramString += 'batchType=' + (tempBatchType ? tempBatchType : '');
    // paramString += '&search=' + ((this.vm.shipmentSearch) ? this.vm.shipmentSearch : '');
    // paramString += '&fromDate=' + ((this.vm.shipmentFromDate) ? this.dateFilter.GetDateFormat(this.vm.shipmentFromDate) : '');
    // paramString += '&toDate=' + ((this.vm.shipmentToDate) ? this.dateFilter.GetDateFormat(this.vm.shipmentToDate) : '');
    paramString += '&lockedBatches=' + (this.vm.lockedBatches ? this.vm.lockedBatches : '');
    // paramString += '&shipmentNumberOfResults=' + ((this.vm.shipmentNumberOfResults) ? this.vm.shipmentNumberOfResults : '');
    // paramString += '&includePosted=' + ((this.vm.includePosted) ? this.vm.includePosted : '');

    this.tableDataService.getData('t_batch', '?' + paramString).subscribe((result: any[]) => {
      this.vm.batches = result;
      if (this.FilterObject(this.vm.batches, {id: this.vm.batchId}, true).length == 1) {
        this.vm.tempDescription = this.FilterObject(this.vm.batches, {id: this.vm.batchId}, true)[0].description;
        this.vm.tempBatchLocked = this.FilterObject(this.vm.batches, {id: this.vm.batchId}, true)[0].locked;
      }
      this.vm.searching = false;
    });
  }
  filter(filterItem) {
    this.vm.shipmentFilter = Object.assign(this.vm.shipmentFilter, filterItem);
    // this.localStorage.StorageSet('shipmentFilter', this.vm.shipmentFilter);
  }

  FilterObject(value, filterObj, except = false) {
    return new FilterPipe().transform(value, filterObj);
  }

  onNavigate(id: any, print = false) {
    this.tableDataService
      .getApiListData('entity?state=active&pageNumber=0&pageSize=999999')
      .subscribe((result: ResponseModel) => {
        // this.localStorage.StorageSet('entity', JSON.stringify(result.Data));
        if (print) {
          // Option B: Print directly from list using shared document service (no navigation)
          this.printShipment(id);
        } else {
          this.router.navigate(['/transactions/shipment/form'], {
            queryParams: {shipmentId: id, type: this.vm.type, subLedger: this.vm.subLedger},
          });
        }
      });
  }

  /**
   * Print the shipment document directly from the list using the shared service.
   * This avoids routing flicker and reuses the same multi-page layout.
   */
  printShipment(id: string) {
    try {
      const sub = this.vm?.subLedger || undefined;
      this.shipmentDoc.printById(id, sub);
    } catch (e) {
      // If DI not ready for some reason, fallback to navigation-based print
      this.router.navigate(['/transactions/shipment/form'], {
        queryParams: {shipmentId: id, autoPrint: '1', type: this.vm.type, subLedger: this.vm.subLedger}
      });
    }
  }

  onNavigateOrder(id: any) {
    const route = this.vm.subLedger === 'ar'
      ? '/transactions/invoice/so/form'
      : '/transactions/invoice/po/form';
    this.router.navigateByUrl(route + '?documentId=' + id, {}).then();
  }


  ngAfterViewInit() {
    if (this.vm.subLedger == 'ap') {
      this.titleService.setTitle($localize`:Purchase Shipments @@purchaseShipments:Purchase Shipments`);
    } else if (this.vm.subLedger == 'ar') {
      this.titleService.setTitle($localize`:Sale Shipments @@saleShipments:Sale Shipments`);
    } else {
      this.titleService.setTitle($localize`:Shipments @@shipments:Shipments`);
    }
  }

  hideBatches() {
    this.vm.batchesHidden = !this.vm.batchesHidden;
  }

  // ----------------- Server side paging --------------------

  protected fetchPage(): void {
    this.getPagedApiData();
  }

  getPagedApiData() {
    this.vm.searching = true;
    // this.vm.batchId = '';
    this.vm.tempDescription = '';
    let tempBatchType;
    if (this.vm.subLedger == 'ap') {
      tempBatchType = '12';
    } else if (this.vm.subLedger == 'ar') {
      tempBatchType = '11';
    }

    let paramString = '';
    paramString += 'batchType=' + (tempBatchType ? tempBatchType : '');
    paramString += '&batchId=' + (this.vm.batchId ? this.vm.batchId : '');
    paramString += '&search=' + (this.vm.shipmentSearch ? this.vm.shipmentSearch : '');
    paramString +=
      '&fromDate=' + (this.vm.shipmentFromDate ? this.dateFilter.GetDateFormat(this.vm.shipmentFromDate) : '');
    paramString += '&toDate=' + (this.vm.shipmentToDate ? this.dateFilter.GetDateFormat(this.vm.shipmentToDate) : '');
    paramString += '&unshipped=' + (this.vm.unshipped ? this.vm.unshipped : '');
    paramString += '&uninvoiced=' + (this.vm.uninvoiced ? this.vm.uninvoiced : '');
    paramString += '&numberOfResults=' + (this.vm.shipmentNumberOfResults ? this.vm.shipmentNumberOfResults : '');
    paramString += '&pageNumber=' + (this.page !== 0 ? this.page - 1 : 0);
    paramString += '&pageSize=' + this.pageSize;

    this.tableDataService.getApiListData('ListShipments?' + paramString).subscribe((result: ResponseModel) => {
      this.vm.list = result.Data;
      this.totalRecords = result.totalRecords;
      this.paginate(false);

      this.convertToNumbers();
      this.vm.searching = false;
    });
  }

  serverSearch(value) {
    this.vm.shipmentSearch = value.searchTerm;
    this.vm.shipmentFromDate = value.fromDate;
    this.vm.shipmentToDate = value.toDate;
    this.page = 1;
    this.getPagedApiData();
  }

  clearServerSearch(value) {
    this.vm.shipmentSearch = value.searchTerm;
    this.vm.shipmentFromDate = value.fromDate;
    this.vm.shipmentToDate = value.toDate;
    this.page = 1;
    this.getPagedApiData();
  }

  hideSearch() {
    this.vm.searchHidden = !this.vm.searchHidden;
  }
}
